import { createFileRoute } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { Page } from "../../../components/page.js";
import { EmptyState } from "@gladis/ui";
import { useT } from "@gladis/ui/i18n";

/**
 * Catch-all, deliberately INSIDE the authenticated layout.
 *
 * An unknown in-app URL must still be guarded: an unauthenticated visitor to `/nonsense` goes to
 * sign-in, and a member with no household goes to onboarding. Outside the layout it would render
 * its own not-found and neither rule would apply.
 *
 * Inside the SHELL as well, so a wrong turn keeps the navigation and is one click from recovery.
 */
export const Route = createFileRoute("/_authenticated/_shell/$")({
  component: NotFound,
});

function NotFound(): ReactNode {
  const t = useT();

  return (
    <Page>
      <Page.Title>{t("shell.notFound")}</Page.Title>
      <Page.Body>
        <div className="col-span-full">
          <EmptyState>{t("shell.notFoundHint")}</EmptyState>
        </div>
      </Page.Body>
    </Page>
  );
}
